// extracted by css-extract-rspack-plugin
export default {"cls1":"ToolsMenu-cls1_L2Q","cls2":"ToolsMenu-cls2_P_O ToolsMenu-cls1_L2Q"};